/** O triângulo do modelo ao lado de "participantes online", quando falta alguém (`RN-RA-008`). */
export function AlertaOffline() {
    return (
        <svg className="alerta-offline" role="img" aria-label="Há participantes offline" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0zM12 9v4M12 17h.01" />
        </svg>
    );
}
